import GeneralProduct from '~/Api/Product/Product';

import { ReferencePrice } from './ReferencePrice';

export class Product {
	constructor(
		public readonly product: GeneralProduct,
		public readonly packageSizeForCalculation: number | null,
		public readonly packageSizeForSingleUnit: number | null,
		public readonly singleUnitPackageSize: boolean,
		public readonly referencePrices: ReferencePrice[],
		public readonly referenceDataSource: boolean,
		public readonly selectable: boolean,
		public readonly selected: boolean,
		public readonly amountOfSubstanceInUnit: number | null
	) {}

	findSelectedReferencePrice(): ReferencePrice | null {
		return this.referencePrices.find((price) => price.calculatedPrice.selected) ?? null;
	}
}
